import { SuccessButton } from '@components/Buttons/SuccessButton';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { FilterBar } from '@components/FilterBar';
import { GridItem } from '@components/GridItem';
import { IFilter } from '@hooks/useFilter';
import { IModalWindow } from '@hooks/useModalWindow';
import { Button } from '@material-ui/core';
import { IVendedorComissaoFilter } from '@services/VendedorComissaoService';
import React from 'react';

export type VendedorInventarioFilterProps = {
    filter: IFilter<IVendedorComissaoFilter>
    isLoading: boolean
    creditoModal: IModalWindow
    debitoModal: IModalWindow
    pagamentoModal: IModalWindow
}

export function VendedorComissaoFilter ({ filter, isLoading, creditoModal, debitoModal, pagamentoModal }: VendedorInventarioFilterProps) {
    const { fields } = filter;

    return (
        <FilterBar>
            <GridItem>
                <SuccessButton onClick={creditoModal.open}>Novo Crédito</SuccessButton>
            </GridItem>
            <GridItem>
                <Button variant="contained" onClick={debitoModal.open} color="secondary">Novo Débito</Button>
            </GridItem>
            <GridItem>
                <Button variant="contained" onClick={pagamentoModal.open}>Novo Pagamento</Button>
            </GridItem>

            <GridItem floatRight xs={1}>
                <CompetenciaField
                    field={fields.competencia}
                    disabled={isLoading}
                    updateFieldStateOnChange
                    onValueChanged={filter.handleFilterRequest}
                />
            </GridItem>
        </FilterBar>
    )
}